import {ff, i18n} from 'mc/lib';
import {Form, FormActions, FormBody} from 'mc/lib/form';
import React from 'react';
import {propTypes, reduxForm} from 'redux-form';

const IdentifikaceForm = ({handleSubmit, onClose}) => (
    <Form onSubmit={handleSubmit}>
        <FormBody>
            <ff.String label={i18n('lokalita.identifikace')} name="identifikace"/>
        </FormBody>
        <FormActions onClose={onClose} storeButton cancelButton/>
    </Form>
);

IdentifikaceForm.formName = 'identifikace';
IdentifikaceForm.propTypes = propTypes;

const formConfig = {
    form: IdentifikaceForm.formName,
};

export default reduxForm(formConfig)(IdentifikaceForm);
